'use client';

import { FC } from 'react';
import { DashboardCard, DashboardCardProps } from '@tuic/web-compositions/shared/DashboardCard';
import { useNotificationCount } from '@lib/hooks/use-notification-count';
type Props = {
  mxp365Token: string | undefined;
  dashboardCard?: DashboardCardProps;
};
export const ChatCard: FC<Props> = ({
  mxp365Token,
  dashboardCard
}) => {
  const {
    notifications = 0,
    chatMessages = 0
  } = useNotificationCount({
    token: mxp365Token
  });
  const sum = notifications + chatMessages;
  return <DashboardCard {...dashboardCard} badge={sum < 1 ? undefined : sum} data-sentry-element="DashboardCard" data-sentry-component="ChatCard" data-sentry-source-file="chat-card.tsx" />;
};